import { render, staticRenderFns } from "./shiftManagementAssistant.vue?vue&type=template&id=c00a31be&scoped=true"
import script from "./shiftManagementAssistant.vue?vue&type=script&lang=js"
export * from "./shiftManagementAssistant.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementAssistant.vue?vue&type=style&index=0&id=c00a31be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00a31be",
  null
  
)

export default component.exports